function initSwipers() {
	document.querySelectorAll('.swiper[data-swiper]').forEach(element => {
		if (element.swiper) return;
		const options = JSON.parse(element.dataset.swiper);
		new Swiper(element, { ...options });
	});
}

initSwipers();

const observer = new MutationObserver(initSwipers);
observer.observe(document.body, { childList: true, subtree: true });
